import { CreateProject } from '@/features/end-of-lease/CreateProject/CreateProject';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/lease/create-project')({
    component: CreateProject,
});
